import { Injectable } from '@angular/core';
import { Report } from '../../interfaces/interfaces';

@Injectable({
  providedIn: 'root'
})

export class ReportListService {
  constructor() {}
  reports: Report[] = [
    {
      id: 0,
      filterName: 'daily',
      title: 'Asistencia diaria personal',
      cardTitle: 'Asistencia diaria personal',
      img: 'assets/icons/info/daily.png',
      desc: 'Relación de personal',
      desc2: 'asistentes por día y agrupado',
      desc3: 'por empresa.',
      type: 'personal',
      permission: 'informsDownload.daily',
      subcontractors: true,
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: undefined, type: 'calendar', filterName: 'calendar'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESA', type: 'all', filterName: 'employerId'},
        {name: 'BUSCAR PERSONAL DIGITANDO ID O CEDULA', type: 'input', filterName: 'personalIds'},
        {name: 'Mostrar sólo la primera entrada y la última salida del día', type: 'toogle', filterName: 'summary'},
        {name: 'Informé con celdas combinadas', type: 'toogle', filterName: 'once'},
        {name: 'Empleador', type: 'group-new', filterName: 'group', valueItem: 0, checked: true},
        {name: 'Contratista', type: 'group-new', filterName: 'group', valueItem: 1, checked: false},
      ]
    },
    {
      id: 1,
      filterName: 'monthlyattendance',
      title: 'Asistencia mensual personal',
      cardTitle: 'Asistencia mensual personal',
      img: 'assets/icons/info/monthlypersongreen.png',
      desc: 'Informe de asistencia mensual de ',
      desc2: 'los trabajadores agrupados por ',
      desc3: 'empresa.',
      type: 'personal',
      permission: 'informsDownload.monthly',
      subcontractors: true,
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: '', filterName: 'projectId'},
        {name: 'EMPRESA', type: 'all', filterName: 'employerId'},
        {name: 'MES', type: 'select', filterName: 'month'},
        {name: 'AÑO', type: 'select', filterName: 'year'},
        {name: 'Empleador', type: 'group-new', filterName: 'group', valueItem: 0, checked: true},
        {name: 'Contratista', type: 'group-new', filterName: 'group', valueItem: 1, checked: false},
      ]
    },
    {
      id: 2,
      filterName: 'monthlysummary',
      title: 'Asistencia mensual total',
      cardTitle: 'Asistencia mensual total',
      img: 'assets/icons/info/monthlysummary.png',
      desc: 'Informe de asistencia mensual de ',
      desc2: 'los trabajadores agrupados por ',
      desc3: 'empresa y totalizado por mes.',
      type: 'personal',
      permission: 'informsDownload.monthlysummary',
      subcontractors: true,
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: '', filterName: 'projectId'},
        {name: 'EMPRESA', type: 'all', filterName: 'employerId'},
        {name: 'MES', type: 'select', filterName: 'month'},
        {name: 'AÑO', type: 'select', filterName: 'year'},
        {name: 'Empleador', type: 'group-new', filterName: 'group', valueItem: 0, checked: true},
        {name: 'Contratista', type: 'group-new', filterName: 'group', valueItem: 1, checked: false},
      ]
    },
    {
      id: 5,
      title: 'Asistencia mensual por función',
      filterName: 'attendancebyposition',
      cardTitle: 'ASISTENCIA MENSUAL POR FUNCIÓN',
      img: 'assets/icons/info/attendancebypos.png',
      desc: 'Relación del personal asistente por',
      desc2: 'función agrupado por empleador.',
      type: 'personal',
      permission: 'informsDownload.attendancebypos',
      subcontractors: true,
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: '', filterName: 'projectId'},
        {name: 'EMPRESA EMPLEADORA', type: 'all', filterName: 'employerId'},
        {name: 'MES', type: 'select', filterName: 'month'},
        {name: 'AÑO', type: 'select', filterName: 'year'},
      ]
    },
    {
      id: 17,
      filterName: 'firstlastpersonal',
      title: 'Asistencia inicial y final',
      cardTitle: 'Asistencia inicial y final',
      img: 'assets/icons/info/firstlastpersonal.png',
      desc: 'Informe con el primer y ultimo registro',
      desc2: 'de ingreso de cada  trabajador',
      desc3: 'agrupado por contrato.',
      type: 'personal',
      permission: 'informsdownload.firstlastpersonal',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'CONTRATOS', type: 'all', filterName: 'ContractIds'},
      ]
    },
    {
      id: 22,
      filterName: 'DateRange',
      title: 'Entradas y Salidas',
      cardTitle: 'Entradas y Salidas',
      img: 'assets/icons/info/calendario.png',
      desc: 'Informe mensual de entradas, salidas',
      desc2: 'e inspecciónes en un proyecto.',
      desc3: 'agrupado por empresa.',
      type: 'personal',
      permission: 'informsDownload.entriesrange',
      subcontractors: true,
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: '', filterName: 'projectId'},
        {name: 'EMPRESA', type: 'all', filterName: 'employerId'},
        {name: 'Mostrar solo la primera entrada y la ultima  salida del día', type: 'toogle', filterName: 'once'},
        {name: 'Informé con celdas combinadas', type: 'toogle', filterName: 'summary'},
        {name: 'Empleador', type: 'group-new', filterName: 'group', valueItem: 0, checked: true},
        {name: 'Contratista', type: 'group-new', filterName: 'group', valueItem: 1, checked: false},
      ]
    },
    {
      id: 3,
      filterName: 'monthly',
      title: 'Entradas y Salidas Mensual',
      cardTitle: 'Entradas y Salidas Mensual',
      img: 'assets/icons/info/entries.png',
      desc: 'Informe mensual de entradas, salidas',
      desc2: 'e inspecciónes en un proyecto.',
      desc3: 'agrupado por empresa.',
      type: 'personal',
      permission: 'informsDownload.entries',
      subcontractors: true,
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: '', filterName: 'projectId'},
        {name: 'EMPRESA', type: 'all', filterName: 'employerId'},
        {name: 'MES', type: 'select', filterName: 'month'},
        {name: 'AÑO', type: 'select', filterName: 'year'},
        {name: 'Mostrar solo la primera entrada y la ultima  salida del día', type: 'toogle', filterName: 'once'},
        {name: 'Informé con celdas combinadas', type: 'toogle', filterName: 'summary'},
        {name: 'Empleador', type: 'group-new', filterName: 'group', valueItem: 0, checked: true},
        {name: 'Contratista', type: 'group-new', filterName: 'group', valueItem: 1, checked: false},
      ]
    },
    {
      id: 4,
      filterName: 'DateRange',
      title: 'Entradas y Salidas por persona',
      cardTitle: 'Entradas y Salidas por persona',
      img: 'assets/images/entries_person.png',
      desc: 'Informe de entradas, salidas',
      desc2: 'e inspecciónes por persona en',
      desc3: 'un rango de fechas.',
      type: 'personal',
      permission: 'informsDownload.entriesbyperson',
      subcontractors: true,
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'startDate', type: 'calendar', filterName: 'startDate'},
        {name: 'endDate', type: 'calendar', filterName: 'endDate'},
        {name: 'BUSCAR PERSONAL DIGITANDO ID O CEDULA', type: 'input', filterName: 'personalIds'},
        {name: 'Informé con celdas combinadas', type: 'toogle', filterName: 'summary'},
      ]
    },
    {
      id: 6,
      filterName: 'absent',
      title: 'Personal activo y ausente',
      cardTitle: 'Personal activo y ausente',
      img: 'assets/icons/info/absent.png',
      desc: 'Relación de personal activo',
      desc2: 'sin registro de ingreso.',
      desc3: 'agrupado por empleador.',
      type: 'personal',
      permission: 'informsDownload.absent',
      subcontractors: true,
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: '', type: 'calendar', filterName: 'calendar'},
        {name: 'PROYECTOS', type: '', filterName: 'projectId'},
        {name: 'EMPRESA EMPLEADORA', type: 'all', filterName: 'employerId'},
      ]
    },
    {
      id: 7,
      filterName: 'newpersonal',
      title: 'Personal nuevo',
      cardTitle: 'PERSONAL RECIENTEMENTE VINCULADO',
      img: 'assets/icons/info/newpersonal.png',
      desc: 'Relación de personal recien',
      desc2: ' vinculado a un contrato,',
      desc3: 'agrupado por empleador.',
      type: 'personal',
      permission: 'informsDownload.newpersonal',
      subcontractors: true,
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESA EMPLEADORA', type: 'all', filterName: 'employerId'},
      ]
    },
    {
      // NOTA!! NO MODIFICAR ID POR LOGICA OJO! mirar js idReport
      id: 8,
      filterName: 'retiredpersonal',
      title: 'Personal Retirado',
      cardTitle: 'PERSONAL RECIENTEMENTE RETIRADO',
      img: 'assets/icons/info/man-worker.png',
      desc: 'Relación de personal retirado',
      desc2: ' en un contrato del proyecto,',
      desc3: 'agrupado por empleador.',
      type: 'personal',
      permission: 'informsDownload.retiredpersonal',
      subcontractors: true,
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESA EMPLEADORA', type: 'all', filterName: 'employerId'},
      ]
    },
    {
      id: 9,
      filterName: 'completelyretiredpersonal',
      title: 'Personal Retirado por administradora',
      cardTitle: 'PERSONAL RETIRADO POR ADMINISTRADORA',
      img: 'assets/icons/info/man-worker.png',
      desc: 'Fechas de retiro del personal',
      desc2: ' al contrato del proyecto o en',
      desc3: 'toda la empresa',
      type: 'personal',
      permission: 'informsDownload.completelyretiredpersonal',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
        {name: 'MES', type: 'select', filterName: 'month'},
        {name: 'AÑO', type: 'select', filterName: 'year'},
      ]
    },
    {
      id: 10,
      filterName: 'verifikqueries',
      title: 'Personal consultado',
      cardTitle: 'Personal consultado',
      img: 'assets/icons/info/verifikqueries.png',
      desc: 'Relación de las consultas ',
      desc2: 'instantaneas realizadas al ',
      desc3: 'personal. ',
      type: 'personal',
      permission: 'informsdownload.verifikqueries',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'USUARIOS', type: 'all', filterName: 'userIds'},
        {name: 'MES', type: 'select', filterName: 'month'},
        {name: 'AÑO', type: 'select', filterName: 'year'},
      ]
    },
    {
      id: 11,
      filterName: 'personalbycontract',
      title: 'Personal por contrato',
      cardTitle: 'Personal por contrato',
      img: 'assets/icons/info/personalbycontract.png',
      desc: 'Relación de personal agrupado ',
      desc2: 'por contrato',
      type: 'personal',
      permission: 'informsDownload.personalbycontract',
      subcontractors: false,
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESA CONTRATISTA', type: 'all', filterName: 'employerId'},
        {name: 'Fecha fin de acceso', type: '', filterName: 'personalIsActive', firstItem: true},
        {name: 'Seguridad social - ARL', type: '', filterName: 'active_arl'},
        {name: 'Seguridad social - ARL', type: '', filterName: 'expired_arl'},
        {name: 'Examen medico', type: '', filterName: 'active_medical'},
        {name: 'Examen medico', type: '', filterName: 'expired_medical'},
        {name: 'Trabajo en altura', type: '', filterName: 'active_heights'},
        {name: 'Trabajo en altura', type: '', filterName: 'expired_heights'},
        {name: 'Inducción SST', type: '', filterName: 'active_sst'},
        {name: 'Inducción SST', type: '', filterName: 'expired_sst', latest: true },
      ]
    },
    {
      id: 12,
      filterName: 'consolidated',
      title: 'Personal por contratista',
      cardTitle: 'Personal por contratista',
      img: 'assets/icons/info/consolidated.png',
      desc: 'Relación de personal agrupado ',
      desc2: 'por empresa contratista',
      type: 'personal',
      permission: 'informsDownload.consolidated',
      subcontractors: false,
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESA CONTRATISTA', type: 'all', filterName: 'employerId'},
        {name: 'Fecha fin de acceso', type: '', filterName: 'personalIsActive', firstItem: true},
        {name: 'Seguridad social - ARL', type: '', filterName: 'active_arl'},
        {name: 'Seguridad social - ARL', type: '', filterName: 'expired_arl'},
        {name: 'Examen medico', type: '', filterName: 'active_medical'},
        {name: 'Examen medico', type: '', filterName: 'expired_medical'},
        {name: 'Trabajo en altura', type: '', filterName: 'active_heights'},
        {name: 'Trabajo en altura', type: '', filterName: 'expired_heights'},
        {name: 'Inducción SST', type: '', filterName: 'active_sst'},
        {name: 'Inducción SST', type: '', filterName: 'expired_sst', latest: true },
      ]
    },
    {
      id: 13,
      filterName: 'PersonalFull',
      title: 'Personal por empleador',
      cardTitle: 'Personal por empleador',
      img: 'assets/icons/info/PersonalFull.png',
      desc: 'Relación de personal agrupado ',
      desc2: 'por empresa empleador',
      type: 'personal',
      permission: 'informsDownload.personalfull',
      subcontractors: true,
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESA EMPLEADORA', type: 'all', filterName: 'employerId'},
        {name: 'Fecha fin de acceso', type: '', filterName: 'personalIsActive', firstItem: true},
        {name: 'Seguridad social - ARL', type: '', filterName: 'active_arl'},
        {name: 'Seguridad social - ARL', type: '', filterName: 'expired_arl'},
        {name: 'Examen medico', type: '', filterName: 'active_medical'},
        {name: 'Examen medico', type: '', filterName: 'expired_medical'},
        {name: 'Trabajo en altura', type: '', filterName: 'active_heights'},
        {name: 'Trabajo en altura', type: '', filterName: 'expired_heights'},
        {name: 'Inducción SST', type: '', filterName: 'active_sst'},
        {name: 'Inducción SST', type: '', filterName: 'expired_sst', latest: true },
      ]
    },
    {
      id: 14,
      filterName: 'symptoms',
      title: 'Reporte de síntomas',
      cardTitle: 'REPORTE DE SÍNTOMAS',
      img: 'assets/icons/info/sysmptoms.png',
      desc: 'Informe con los síntomas Covid19',
      desc2: ' reportados por los trabajadores',
      type: 'personal',
      covidReport: true,
      permission: 'informsDownload.sysmptoms',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: undefined, type: 'calendar', filterName: 'calendar'},
        {name: 'PROYECTOS', type: '', filterName: 'projectId'},
      ]
    },
    {
      id: 15,
      filterName: 'vaccine',
      title: 'VACUNACIÓN COVID19',
      cardTitle: 'INFORME DE ESTADO VACUNACIÓN',
      img: 'assets/icons/info/vaccine.png',
      desc: 'Informe del estado de vacunación ',
      desc2: 'de los trabajadores',
      desc3: ' ',
      type: 'personal',
      permission: 'informsDownload.vaccine',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
      ],
      vaccine: true
    },
    {
      id: 16,
      filterName: 'contractingstages',
      title: 'ESTADO DE INGRESOS',
      cardTitle: 'ESTADO DE INGRESOS',
      img: 'assets/icons/info/solicitudesIngreso.png',
      desc: 'Informe con el estado de cada solicitud.',
      desc2: ' ',
      type: 'personal',
      permission: 'informsdownload.contractingrequest',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
        {name: 'MES', type: 'select', filterName: 'month'},
        {name: 'AÑO', type: 'select', filterName: 'year'},
      ]
    },
    {
      id: 21,
      filterName: 'contractingstagechanges',
      title: 'CAMBIOS DE INGRESOS',
      cardTitle: 'CAMBIOS DE INGRESOS',
      img: 'assets/images/informes/requesthist.png',
      desc: 'Informe con los cambios de estados',
      desc2: 'de las solicitudes.',
      type: 'personal',
      permission: 'informsDownload.requestchanges',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
      ]
    },
    {
      id: 25,
      filterName: 'contractingemployercount',
      title: 'CANTIDAD DE INGRESOS',
      cardTitle: 'CANTIDAD DE INGRESOS',
      img: 'assets/icons/info/contracting-request-count.png',
      desc: 'Cantidad de solicitudes de ingreso',
      desc2: 'realizadas por cada empresa.',
      type: 'personal',
      subcontractors: true,
      permission: 'informsDownload.contractingrecuestscount',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTO', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESA', type: 'all', filterName: 'employerId'},
      ]
    },
    {
      id: 23,
      filterName: 'contractingemployercountbyperiod',
      title: 'INGRESOS DE PERSONAL/EMPRESA',
      cardTitle: 'INGRESOS DE PERSONAL/EMPRESA',
      img: 'assets/images/ingresos-personal-empresa.png',
      desc: 'Cantidad de solicitudes de ingreso',
      desc2: 'realizadas por cada empresa en un',
      desc3: 'rango de fecha determinado.',
      type: 'personal',
      permission: 'informsDownload.contractingrecuestsbyperiod',
      form: [
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
      ]
    },
    {
      id: 31,
      filterName: 'contractingemployercountbyperioduser',
      title: 'INGRESOS DE PERSONAL/USUARIO',
      cardTitle: 'INGRESOS DE PERSONAL/USUARIO',
      img: 'assets/images/ingresos-personal-usuario.png',
      desc: 'Relación de solicitud de ingreso',
      desc2: 'tramitados por usuario en un rango',
      desc3: 'de fecha.',
      type: 'personal',
      permission: 'informsDownload.entriesbyuser',
      form: [
        {name: 'USUARIOS', type: '', filterName: 'userIds'},
      ]
    },
    // 17 este informe esta creado
    {
      id: 18,
      filterName: 'terminationRequest',
      title: 'ESTADO DE RETIROS',
      cardTitle: 'ESTADO DE RETIROS',
      img: 'assets/icons/info/personaltermination.png',
      desc: 'Informe con el estado de cada solicitud.',
      desc2: ' ',
      type: 'personal',
      permission: 'informsDownload.personalterminations',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
        {name: 'MES', type: 'select', filterName: 'month'},
        {name: 'AÑO', type: 'select', filterName: 'year'},
      ]
    },
    {
      id: 32,
      filterName: 'terminationmanager',
      title: 'RETIROS DE PERSONAL/EMPRESA',
      cardTitle: 'RETIROS DE PERSONAL/EMPRESA',
      img: 'assets/images/retirmentsbyemployer.png',
      desc: 'Cantidad de solicitudes de retiro',
      desc2: 'realizadas por cada empresa en un',
      desc3: 'rango de fecha.',
      type: 'personal',
      permission: 'informsDownload.terminationmanager',
      form: [
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
      ]
    },
    {
      id: 33,
      filterName: 'TerminationManagerUser',
      title: 'RETIROS DE PERSONAL/USUARIO',
      cardTitle: 'RETIROS DE PERSONAL/USUARIO',
      img: 'assets/images/retirementsbyuser.png',
      desc: 'Relación de solicitud de retiro',
      desc2: 'tramitados por usuario en un rango',
      desc3: 'de fecha.',
      type: 'personal',
      permission: 'informsDownload.terminationmanageruser',
      form: [
        {name: 'USUARIOS', type: '', filterName: 'userIds'},
      ]
    },
    {
      id: 27,
      filterName: 'documentmanager',
      title: 'GESTOR DE DOC. PERSONAL/EMPRESA',
      cardTitle: 'GESTOR DE DOC. PERSONAL/EMPRESA',
      img: 'assets/images/document-manager.png',
      desc: 'Cantidad de solicitudes realizadas',
      desc2: 'por cada empresa en un rango de',
      desc3: 'fecha determinado.',
      type: 'personal',
      permission: 'informsDownload.documentmanager',
      form: [
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
        {name: 'DOCUMENTOS', type: 'all', filterName: 'supplyId'},
      ]
    },
    {
      id: 28,
      filterName: 'documentmanageruser',
      title: 'GESTOR DE DOC. PERSONAL/USUARIO',
      cardTitle: 'GESTOR DE DOC. PERSONAL/USUARIO',
      img: 'assets/images/documentmanager.png',
      desc: 'Relación de documentos tramitados',
      desc2: 'por usuario en un rango fecha.',
      type: 'personal',
      permission: 'informsDownload.documentmanageruser',
      form: [
        {name: 'USUARIOS', type: '', filterName: 'userIds'},
      ]
    },
    {
      id: 29,
      filterName: 'socsecmanager',
      title: 'GESTOR DE PLANILLAS S.S/EMPRESA',
      cardTitle: 'GESTOR DE PLANILLAS S.S/EMPRESA',
      img: 'assets/images/socsecmanager.png',
      desc: 'Cantidad de solicitudes realizadas',
      desc2: 'por cada empresa en un rango de',
      desc3: 'fecha determinado.',
      type: 'personal',
      permission: 'informsDownload.socsecmanager',
      form: [
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
      ]
    },
    {
      id: 30,
      filterName: 'socsecmanageruser',
      title: 'GESTOR DE PLANILLAS S.S/USUARIO',
      cardTitle: 'GESTOR DE PLANILLAS S.S/USUARIO',
      img: 'assets/images/socsecmanageruser.png',
      desc: 'Documentos de Planillas aprobados',
      desc2: 'por usuario en un rango de fechas.',
      type: 'personal',
      permission: 'informsDownload.socsecmanageruser',
      form: [
        {name: 'USUARIOS', type: '', filterName: 'userIds'},
      ]
    },
    {
      id: 36,
      filterName: 'socsecplanilladetail',
      title: 'GESTION DE PLANILLAS PAGADAS/USUARIO',
      cardTitle: 'GESTION DE PLANILLAS PAGADAS/USUARIO',
      img: 'assets/images/blue-card.png',
      desc: 'Cantidad de personal agregado a una',
      desc2: 'planilla pagada por usuario en un',
      desc3: 'rango de fechas.',
      type: 'personal',
      permission: 'informsDownload.socsecplanilladetail',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'USUARIOS', type: '', filterName: 'userIds'},
      ]
    },
    {
      id: 19,
      filterName: 'Novelties',
      title: 'Motivo de novedades',
      cardTitle: 'Motivo de novedades',
      img: 'assets/images/novelties.png',
      desc: 'Informe con los motivos de novedades',
      desc2: 'registradas a cada empleado en un',
      desc3: 'periodo de tiempo.',
      type: 'personal',
      permission: 'informsDownload.novelties',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
        {name: 'startDate', type: 'calendar', filterName: 'startDate'},
        {name: 'endDate', type: 'calendar', filterName: 'endDate'},
      ]
    },
    {
      id: 20,
      filterName: 'PersonalEmployer',
      title: 'CONTRATOS LABORALES',
      cardTitle: 'CONTRATOS LABORALES',
      img: 'assets/images/signing-contract.png',
      desc: 'Relación de todos los contratos',
      desc2: 'laborales activos agrupados por',
      desc3: 'empleador.',
      type: 'personal',
      permission: 'informsDownload.personalemployer',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
      ]
    },
    {
      id: 40,
      filterName: 'BlackList',
      title: 'SANCIONES DE PERSONAL',
      cardTitle: 'SANCIONES DE PERSONAL',
      img: 'assets/icons/info/blacklist.png',
      desc: 'Relación de sanciones del',
      desc2: 'personal.',
      desc3: '',
      type: 'personal',
      permission: 'informsDownload.viewblacklist',
      form: [
        {name: 'EMPRESA EMPLEADORA', type: 'all', filterName: 'employerId'},
      ]
    },
    {
      id: 24,
      filterName: 'extratimerows-apr',
      title: 'Horas Extras aprobadas y recargos',
      cardTitle: 'Horas Extras aprobadas y recargos',
      img: 'assets/icons/info/report-extra-time.png',
      desc: 'Relación de horas extras aprobadas',
      desc2: ' y recargos por periodos de nomina.',
      type: 'personal',
      permission: 'informsDownload.extratime-apr',
      form: [
        {name: 'PROYECTO', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESA', type: '', filterName: 'employerId'},
        {name: 'PERIODO DE NOMINA', type: 'select', filterName: 'payrollTimeId'},
      ]
    },
    {
      id: 34,
      filterName: 'extratime-legal',
      title: 'REPORTE DIARIO DE HORAS EXTRAS',
      cardTitle: 'REPORTE DIARIO DE HORAS EXTRAS',
      img: 'assets/images/daily-overtime.png',
      desc: 'Relación de las horas extras aprobadas',
      desc2: 'por cada trabajador en cada periodo. ',
      desc3: '',
      type: 'personal',
      permission: 'informsDownload.dailyextratime',
      form: [
        {name: 'PROYECTO', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESA', type: '', filterName: 'employerId'},
        {name: 'PERIODO DE NOMINA', type: 'select', filterName: 'payrollTimeId'},
        {name: 'DIGITE EL NÚMERO DE CÉDULA/NIT', type: 'input', filterName: 'documentNumber'},
        {name: 'Solo aprobadas', type: 'toogle', filterName: 'approved'},
      ]
    },
    {
      id: 35,
      filterName: 'extratime-noapr',
      title: 'REPORTE HORAS EXTRAS PENDIENTES APROBAR',
      cardTitle: 'REPORTE HORAS EXTRAS PENDIENTES APROBAR',
      img: 'assets/icons/info/report-extra-time.png',
      desc: 'Relación de las horas extras pendiente',
      desc2: 'por aprobar por cada trabajador en',
      desc3: 'cada periodo.',
      type: 'personal',
      permission: 'informsDownload.pendingextratime',
      form: [
        {name: 'PROYECTO', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESA', type: '', filterName: 'employerId'},
        {name: 'PERIODO DE NOMINA', type: 'select', filterName: 'payrollTimeId'},
      ]
    },
    {
      id: 26,
      filterName: 'extratime-apr',
      title: 'TIEMPO EXTRAS APROBADO',
      cardTitle: 'TIEMPO EXTRAS APROBADO',
      img: 'assets/images/bloked-woker.png',
      desc: 'Relación de tiempo extra aprobados',
      desc2: 'por periodos de nomina.',
      type: 'personal',
      permission: 'informsDownload.extratime-apr-hor',
      form: [
        {name: 'PROYECTO', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESA', type: '', filterName: 'employerId'},
        {name: 'PERIODO DE NOMINA', type: 'select', filterName: 'payrollTimeId'},
      ]
    },
    {
      id: 100,
      filterName: 'socsec',
      title: 'Seguridad Social',
      subcontractors: true,
      cardTitle: 'VIGENCIA DE SEGURIDAD SOCIAL',
      img: 'assets/icons/info/socsec.png',
      desc: 'Relación de personal activo con ',
      desc2: 'fechas de vigencia de su seguridad',
      desc3: ' social',
      type: 'access',
      permission: 'informsDownload.socsec',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
        {name: 'Consolidar todos los proyectos en una sola celda', type: 'toogle', filterName: 'summary'},
        {name: 'Fecha fin de acceso', type: '', filterName: 'personalIsActive', firstItem: true, latest: true },
      ]
    },
    {
      // Descarga vía el endpoint genérico "requirement" con un requirementId fijo (ver ReportIdComponent).
      id: 101,
      filterName: 'requirement',
      requirementId: 8,
      title: 'Certificado de Alturas',
      cardTitle: 'CERTIFICADO DE TRABAJO ALTURAS',
      img: 'assets/icons/info/heights.png',
      desc: 'Agrupado por proyecto y contratista',
      desc2: '',
      type: 'access',
      permission: 'informsDownload.heights',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
        {name: 'Consolidar todos los proyectos en una sola celda', type: 'toogle', filterName: 'summary'},
        {name: 'Fecha fin de acceso', type: '', filterName: 'personalIsActive', firstItem: true, latest: true },
      ]
    },
    {
      // Descarga vía el endpoint genérico "requirement" con un requirementId fijo (ver ReportIdComponent).
      id: 102,
      filterName: 'requirement',
      requirementId: 23,
      title: 'Examen Médico Ocupacional',
      cardTitle: 'VIGENCIA DE EXAMEN MÉDICO',
      img: 'assets/icons/info/medical.png',
      desc: 'Agrupado por proyecto y contratista',
      desc2: '',
      type: 'access',
      permission: 'informsDownload.medical',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
        {name: 'Consolidar todos los proyectos en una sola celda', type: 'toogle', filterName: 'summary'},
        {name: 'Fecha fin de acceso', type: '', filterName: 'personalIsActive', firstItem: true, latest: true },
      ]
    },
    {
      id: 103,
      filterName: 'RequirementAccessReport',
      title: 'Estado de los requisitos',
      cardTitle: 'ESTADO DE LOS REQUISITOS',
      img: 'assets/icons/info/requirements.png',
      method: 'POST',
      desc: 'Informe de estado de los requisitos ',
      desc2: 'de personal agrupado por contrato.',
      type: 'access',
      permission: 'informsDownload.requirements',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: undefined, type: 'calendar', filterName: 'date'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
        {name: 'CONTRATO', type: 'multi', filterName: 'ContractIds'},
        {name: 'BUSCAR PERSONAL DIGITANDO ID O CEDULA', type: 'input', filterName: 'personalIds'},
        {name: 'VIGENCÍA', type: 'select', filterName: 'vigency', value: 0},
        {name: 'ESTADO', type: 'select', filterName: 'state', value: 0},

      ]
    },
    {
      // Descarga vía el endpoint genérico "requirement" con un requirementId fijo (ver ReportIdComponent).
      id: 104,
      filterName: 'requirement',
      requirementId: 57,
      title: 'INDUCCION SST',
      cardTitle: 'INDUCCION SST',
      img: 'assets/icons/info/induction.png',
      desc: 'Agrupado por proyecto y contratista',
      desc2: '',
      type: 'access',
      permission: 'informsDownload.induction',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
        {name: 'Consolidar todos los proyectos en una sola celda', type: 'toogle', filterName: 'summary'},
        {name: 'Fecha fin de acceso', type: '', filterName: 'personalIsActive', firstItem: true, latest: true }
      ]
    },
    {
      // Combo "DOCUMENTO" (requirementId) se carga dinámicamente desde api/Requirement
      // (ver ReportIdComponent, idReport === '105'): selección única, sin opción "Todos".
      id: 105,
      filterName: 'requirement',
      title: 'ESTADO DE DOCUMENTO',
      cardTitle: 'ESTADO DE DOCUMENTO',
      img: 'assets/icons/info/doc-96.png',
      desc: 'Relación de personas agrupadas ',
      desc2: 'por empresa indicando el ',
      desc3: 'estado de un documento.',
      type: 'access',
      permission: 'informsDownload.documentstate',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'DOCUMENTO', type: 'single', filterName: 'requirementId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'Consolidar todos los proyectos en una sola celda', type: 'toogle', filterName: 'summary'},
        {name: 'Fecha fin de acceso', type: '', filterName: 'personalIsActive', firstItem: true, latest: true }
      ]
    },
    {
      id: 150,
      filterName: 'Contractor',
      title: 'RELACIÓN DE EMPRESAS',
      cardTitle: 'Relación de empresas',
      img: 'upload/images/form-images/file_235c080f-43b7-42c6-bd43-0af779cdb223.svg',
      desc: 'Relación de las empresas activas',
      desc2: 'en los proyectos',
      type: 'employer',
      permission: 'informsDownload.contractors',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
        {name: 'EMPRESAS', type: 'all', filterName: 'employerId'},
        {name: 'Consolidar todos los proyectos en una sola celda', type: 'toogle', filterName: 'summary'},
      ]
    },
    {
      id: 151,
      filterName: 'socsecdocument',
      title: 'Estado de planillas de ss',
      cardTitle: 'Estado de planillas de ss',
      img: 'assets/icons/info/state-planilla.png',
      desc: 'Relación con el estado de la ',
      desc2: 'planilla de seguridad social.',
      type: 'employer',
      permission: 'informsDownload.state-planilla',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'}
      ]
    },
    {
      id: 152,
      filterName: 'Contract',
      title: 'Relación de contratos',
      cardTitle: 'Relación de contratos',
      img: 'assets/images/hammer.png',
      desc: 'Relación de contratos por cada ',
      desc2: 'proyecto y por empresa.',
      type: 'employer',
      permission: 'informsDownload.contracts',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'}
      ]
    },
    {
      id: 300,
      filterName: 'dailyvehicle',
      title: 'Asistencia diarias de vehículos',
      cardTitle: 'Asistencia diarias de vehículos',
      img: 'assets/icons/info/dailyvehicle.png',
      desc: 'Relación de vehiculos ',
      desc2: 'asistentes por día. ',
      type: 'vehicle',
      permission: 'informsdownload.dailyvehicle',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: undefined, type: 'calendar', filterName: 'calendar'},
        {name: 'PROYECTOS', type: 'all', filterName: 'projectId'},
      ]
    },
    {
      id: 301,
      filterName: 'monthlyvehicle',
      title: 'Asistencia mensual vehiculos',
      cardTitle: 'Asistencia mensual vehiculos',
      img: 'assets/icons/info/monthlyvehicle.png',
      desc: 'Informe de asistencia mensual de ',
      desc2: 'los vehiculos agrupados por ',
      desc3: 'empleador.',
      type: 'vehicle',
      permission: 'informsDownload.monthlyvehicle',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: '', filterName: 'projectId'},
        {name: 'EMPRESA EMPLEADORA', type: 'all', filterName: 'employerId'},
        {name: 'MES', type: 'select', filterName: 'month'},
        {name: 'AÑO', type: 'select', filterName: 'year'},
      ]
    },
    {
      // NOTA!! NO MODIFICAR ID POR LOGICA OJO! mirar js idReport
      id: 302,
      filterName: 'monthlysupplies',
      title: 'Asistencia mensual de cargas',
      cardTitle: 'Asistencia mensual de cargas',
      img: 'assets/icons/info/monthlysupply.png',
      desc: 'Registro mensual de las cargas que',
      desc2: 'ingresan y salen por proyecto.',
      type: 'vehicle',
      permission: 'informsDownload.monthlysupplies',
      form: [
        {name: 'ADMINISTRADORA', type: 'select', filterName: 'CompanyId'},
        {name: 'PROYECTOS', type: '', filterName: 'projectId'},
        {name: 'EMPRESA EMPLEADORA', type: 'all', filterName: 'employerId'},
        {name: 'INSUMOS', type: 'all', filterName: 'supplyId'},
        {name: 'startDate', type: 'calendar', filterName: 'startDate'},
        {name: 'endDate', type: 'calendar', filterName: 'endDate'},
      ]
    },
  ];
}
